export const NOTIFY_LOCALE_ZHCHS = {
    title: 'ç³»ç»æç¤º'
};
